module.exports = __webpack_public_path__ + "static/hero-51690be104661e7bcb888a173e8536a8.jpg";